function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Store from "@ember-data/store";
import HealthCentre from "core/models/health-centre";
import HealthCentreTag from "core/models/health-centre-tag";
import Medic from "core/models/medic";
export const filterSeparator = "_";
export const keyValueSeparator = "%3D";
export class PatientListFilterParser {
  constructor({
    serializedFilter,
    store
  }) {
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "filters", void 0);
    this.filters = this.deserialize(serializedFilter);
    this.store = store;
  }
  deserialize(serializedFilter) {
    return serializedFilter?.split(filterSeparator).reduce((acc, cur) => {
      const [key, value] = cur.split(keyValueSeparator);
      acc[key] = value;
      return acc;
    }, {});
  }
  serialize(filters) {
    return Object.keys(filters).map(key => `${key}${keyValueSeparator}${filters[key]}`).join(filterSeparator);
  }
  get serializedFilter() {
    return this.serialize(this.filters);
  }
  get patientStatus() {
    const status = this.filters.patientStatus;
    return ["enrolled", "not-enrolled", "disenrolled"].includes(status) ? status : undefined;
  }
  set patientStatus(filter) {
    this.filters.patientStatus = filter || "";
  }
  get patientFur() {
    return this.filters.fur;
  }
  set patientFur(filter) {
    this.filters.fur = filter;
  }
  get taskType() {
    return this.filters.taskType;
  }
  set taskType(filter) {
    this.filters.taskType = filter;
  }
  get responsibleId() {
    return this.filters.responsibleId;
  }
  set responsibleId(filter) {
    this.filters.responsibleId = filter;
  }
  get tlsConsentStatus() {
    return this.filters.tlsConsentStatus;
  }
  set tlsConsentStatus(filter) {
    this.filters.tlsConsentStatus = filter;
  }
  get medic() {
    if (this.filters.medicId && this.filters.medicId != "undefined") {
      return this.store.peekRecord("medic", this.filters.medicId);
    }
    return null;
  }
  set medic(filter) {
    this.filters.medicId = filter;
  }
  get allMedic() {
    return this.filters.medicId == "all";
  }
  get healthCentre() {
    if (this.filters.healthCentreId && this.filters.healthCentreId != "undefined") {
      return this.store.peekRecord("health-centre", this.filters.healthCentreId);
    }
    return null;
  }
  set healthCentre(filter) {
    this.filters.healthCentreId = filter;
  }
  get allHealthCentre() {
    return this.filters.healthCentreId == "all";
  }
  get healthCentreTag() {
    if (this.filters.healthCentreTagId && this.filters.healthCentreTagId != "undefined") {
      return this.store.peekRecord("health-centre-tag", this.filters.healthCentreTagId);
    }
    return null;
  }
  set healthCentreTag(filter) {
    this.filters.healthCentreTagId = filter;
  }
  get isValid() {
    return Boolean(this.patientStatus && (this.medic || this.allMedic) && (this.healthCentre || this.allHealthCentre || this.healthCentreTag));
  }
}

/**
 * Helps transform a filter string to options suitable for calling the API.
 */
export default class PatientListFilterSerializer {
  constructor({
    serializedFilter,
    store
  }) {
    _defineProperty(this, "serializedFilter", void 0);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "parser", void 0);
    this.serializedFilter = serializedFilter;
    this.store = store;
    this.parser = new PatientListFilterParser({
      serializedFilter,
      store
    });
  }
  get translationKey() {
    let name;
    if (this.parser.medic) {
      name = this.parser.medic.fullName;
    }
    if (this.parser.healthCentre) {
      name = this.parser.healthCentre.name;
    }
    if (this.parser.healthCentreTag) {
      name = this.parser.healthCentreTag.tagTitle;
    }
    return {
      status: this.parser.patientStatus,
      name
    };
  }
  get patientApiFilter() {
    const filters = {};
    if (this.parser.medic) {
      filters.medics = [this.parser.medic.id];
    }
    if (this.parser.healthCentre) {
      filters.health_centres = [this.parser.healthCentre.id];
    }
    if (this.parser.healthCentreTag) {
      filters.health_centres = this.parser.healthCentreTag.healthCentres.map(hc => hc.id);
    }
    if (this.parser.patientFur && this.parser.patientFur != "all") {
      filters.furs = [this.parser.patientFur];
    }
    if (this.parser.patientStatus) {
      filters[this.parser.patientStatus.replace("-", "_")] = "";
    }
    if (this.parser.tlsConsentStatus && this.parser.tlsConsentStatus != "all") {
      filters.tls_consent_status = this.parser.tlsConsentStatus;
    }
    return filters;
  }
  get journalEventsApiFilter() {
    const filters = {};
    if (this.parser.medic) {
      filters.of_patients_followed_by_medics = [this.parser.medic.id];
    }
    if (this.parser.healthCentre) {
      filters.of_patients_followed_by_health_centres = [this.parser.healthCentre.id];
    }
    if (this.parser.healthCentreTag) {
      filters.of_patients_followed_by_health_centres = this.parser.healthCentreTag.healthCentres.map(hc => hc.id);
    }
    if (this.parser.patientFur && this.parser.patientFur != "all") {
      filters["fur"] = this.parser.patientFur;
    }
    if (this.parser.patientStatus) {
      filters[`of_${this.parser.patientStatus.replace("-", "_")}_patients`] = "";
    }
    if (this.parser.tlsConsentStatus && this.parser.tlsConsentStatus != "all") {
      filters["tls_consent_status"] = this.parser.tlsConsentStatus;
    }
    return filters;
  }
  get medicRelatedJournalEventApiFilter() {
    const filters = {};
    if (this.parser.medic) {
      filters.of_medics = this.parser.medic.id;
    } else if (this.parser.healthCentre) {
      filters.of_medic_belonging_to_health_centres = [this.parser.healthCentre.id];
    }
    return filters;
  }
}